<template>
  <section class="header-postmatch-game">
    <div class="header-postmatch-game__cont-data-info">
      <div class="header-postmatch-game__cont-data-info__title">
        ANÁLISIS <span class="header-postmatch-game__cont-data-info__title__bold">TIEMPO EFECTIVO</span>
      </div>

      <div class="header-postmatch-game__cont-data-info__leyend">
        Tiempo efectivo:
        <span class="header-postmatch-game__cont-data-info__leyend__bold">{{
          headerInfoPostMatch.effective_time_min
        }}</span>
        minutos y
        <span class="header-postmatch-game__cont-data-info__leyend__bold">{{
          headerInfoPostMatch.effective_time_seg
        }}</span>
        segundos
      </div>
      <div class="header-postmatch-game__cont-data-info__cont-game">
        <div class="header-postmatch-game__cont-data-info__cont-game__item">
          <div class="header-postmatch-game__cont-data-info__cont-game__item__imgteam">
            <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + headerInfoPostMatch.home_team + '.png'" />
          </div>
          <div class="header-postmatch-game__cont-data-info__cont-game__item__vs">
            {{ headerInfoPostMatch.score[0] }}&nbsp;&nbsp;&nbsp;
            <div style="visibility: hidden; width: 20px;">-</div>
            &nbsp;&nbsp;&nbsp;{{ headerInfoPostMatch.score[1] }}
          </div>
          <div class="header-postmatch-game__cont-data-info__cont-game__item__imgteam">
            <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + headerInfoPostMatch.visiting_team + '.png'" />
          </div>
        </div>
      </div>
    </div>
    <div class="header-postmatch-game__cont-infoby-game">
      <div class="header-postmatch-game__cont-infoby-game__goals-section">
        <div class="header-postmatch-game__cont-infoby-game__goals-section__row-title">Goles</div>
        <div class="header-postmatch-game__cont-infoby-game__goals-section__row">
          <div class="header-postmatch-game__cont-infoby-game__goals-section__row__shield">
            <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + headerInfoPostMatch.home_team + '.png'" />
          </div>
          <div class="header-postmatch-game__cont-infoby-game__goals-section__row__goals-cont-items">
            <template v-for="(item, index) in headerInfoPostMatch.home_goals_minutes">
              <div
                :key="index"
                class="header-postmatch-game__cont-infoby-game__goals-section__row__goals-cont-items__goal"
              >
                {{ item }}<template v-if="index + 1 < headerInfoPostMatch.home_goals_minutes.length">,</template>
              </div>
            </template>
          </div>
        </div>
        <div class="header-postmatch-game__cont-infoby-game__goals-section__row">
          <div class="header-postmatch-game__cont-infoby-game__goals-section__row__shield">
            <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + headerInfoPostMatch.visiting_team + '.png'" />
          </div>
          <div class="header-postmatch-game__cont-infoby-game__goals-section__row__goals-cont-items">
            <template v-for="(item, index) in headerInfoPostMatch.visiting_goals_minutes">
              <div
                :key="index"
                class="header-postmatch-game__cont-infoby-game__goals-section__row__goals-cont-items__goal"
              >
                {{ item }}<template v-if="index + 1 < headerInfoPostMatch.visiting_goals_minutes.length">,</template>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="header-postmatch-game__cont-infoby-game__time-section">
        <div class="header-postmatch-game__cont-infoby-game__time-section__row-header">
          <div class="header-postmatch-game__cont-infoby-game__time-section__row-header__col">Tiempo</div>
          <div class="header-postmatch-game__cont-infoby-game__time-section__row-header__col">
            Tiempo<br />
            Agregado
          </div>
          <div class="header-postmatch-game__cont-infoby-game__time-section__row-header__col">
            % Tiempo<br />
            Efectivo
          </div>
        </div>
        <div class="header-postmatch-game__cont-infoby-game__time-section__row white-color">
          <div class="header-postmatch-game__cont-infoby-game__time-section__row__col">1T</div>
          <div class="header-postmatch-game__cont-infoby-game__time-section__row__col">
            {{ headerInfoPostMatch.matchlapses['1T'].additional_time }}
          </div>
          <div class="header-postmatch-game__cont-infoby-game__time-section__row__col">
            {{ headerInfoPostMatch.matchlapses['1T'].active_time_percent }}%
          </div>
        </div>
        <div class="header-postmatch-game__cont-infoby-game__time-section__row">
          <div class="header-postmatch-game__cont-infoby-game__time-section__row__col">2T</div>
          <div class="header-postmatch-game__cont-infoby-game__time-section__row__col">
            {{ headerInfoPostMatch.matchlapses['2T'].additional_time }}
          </div>
          <div class="header-postmatch-game__cont-infoby-game__time-section__row__col">
            {{ headerInfoPostMatch.matchlapses['2T'].active_time_percent }}%
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeaderPostmatchGame',
  components: {},
  props: {
    headerInfoPostMatch: {
      type: Object,
      required: true,
    },
  },
  computed: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style></style>
<style lang="scss" scoped>
.white-color {
  background: white !important;
}
.header-postmatch-game {
  width: 100%;
  height: 109px;
  margin-top: 14px;
  // background: pink;
  display: inline-flex;
  justify-content: left;
  align-content: center;
  align-items: center;
  @media screen and (max-width: 930px) {
    display: inline-block;
    height: auto;
  }
  @media screen and (max-width: 830px) {
    margin-top: 0px;
  }

  &__cont-data-info {
    width: 33.36%;
    height: 109px;
    // background: rgb(143, 0, 24);
    @media screen and (max-width: 930px) {
      margin: 0 auto;
      width: 48.36%;
    }
    @media screen and (max-width: 740px) {
      width: 58.36%;
    }

    @media screen and (max-width: 600px) {
      width: 68.36%;
    }
    @media screen and (max-width: 480px) {
      width: 78.36%;
    }
    @media screen and (max-width: 400px) {
      width: 85%;
    }
    @media screen and (max-width: 380px) {
      width: 100%;
    }
    &__title {
      width: 100%;
      height: 16px;
      // background: gold;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 17px;
      letter-spacing: normal;
      text-align: center;
      color: #132839;
      font-family: 'Avenir-Regular';
      &__bold {
        font-family: 'Avenir-Bold';
      }
      @media screen and (max-width: 1030px) {
        font-size: 19px;
      }
      @media screen and (max-width: 830px) {
        display: none;
      }
      @media screen and (max-width: 380px) {
        font-size: 17px;
      }
    }
    &__leyend {
      width: 100%;
      height: 25px;
      margin-top: 14px;
      border-radius: 6px;
      background-color: #86c200;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 25px;
      letter-spacing: normal;
      text-align: center;
      font-family: 'Avenir-Regular';
      color: #fff;
      &__bold {
        font-family: 'Avenir-Bold';
      }
      @media screen and (max-width: 1030px) {
        font-size: 13px;
      }
    }
    &__cont-game {
      width: 100%;
      height: 40px;
      margin-top: 14px;
      // background: gold;
      &__item {
        width: 228px;
        height: 40px;
        // background: rgb(112, 3, 21);
        display: inline-flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        &__imgteam {
          width: 40px;
          height: 40px;
          // background: rgb(4, 153, 78);
          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
          img {
            width: 40px;
          }
        }
        &__vs {
          width: 148px;
          height: 40px;
          // background: green;
          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
          font-size: 23px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.39;
          letter-spacing: normal;
          text-align: center;
          color: #132839;
          font-family: 'Avenir-Bold';
        }
      }
    }
  }
  &__cont-infoby-game {
    width: 64.12%;
    height: 109px;
    margin-left: 2.5%;
    // background: rgb(143, 0, 24);
    display: inline-flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;

    @media screen and (max-width: 930px) {
      margin-top: 10px;
      margin-left: 0%;
      width: 100%;
    }
    @media screen and (max-width: 740px) {
      display: inline-block;
      height: auto;
    }
    &__goals-section {
      width: 62.8%;
      height: 109px;
      border-radius: 6px;
      border: solid 1px #b4c9dd;
      overflow: hidden;
      @media screen and (max-width: 930px) {
        width: 49%;
      }
      @media screen and (max-width: 740px) {
        width: 100%;
      }
      &__row-title {
        width: 100%;
        height: 36px;
        border-bottom: 1px dotted #b4c9dd;
        font-size: 20px;
        font-family: 'Avenir-Medium';
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 38px;
        letter-spacing: normal;
        text-align: center;
        color: #132839;
      }
      &__row {
        width: 100%;
        height: 37px;
        border-bottom: 1px dotted #b4c9dd;
        display: inline-flex;
        justify-content: left;
        align-content: center;
        align-items: center;
        &__shield {
          width: 10%;
          height: 36px;
          // background: cyan;
          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
          img {
            width: 20px;
            @media screen and (max-width: 400px) {
              width: 24px;
            }
          }
          @media screen and (max-width: 400px) {
            width: 15%;
          }
        }
        &__goals-cont-items {
          width: 90%;
          height: 36px;
          // background: magenta;
          display: inline-flex;
          justify-content: left;
          align-content: center;
          align-items: center;
          @media screen and (max-width: 400px) {
            width: 85%;
          }
          &__goal {
            width: 10%;
            height: 36px;
            // background: brown;
            font-size: 13px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 36px;
            letter-spacing: normal;
            text-align: center;
            color: #132839;
            font-family: 'Avenir-Medium';
            @media screen and (max-width: 400px) {
              width: 12%;
            }
          }
        }
      }
    }
    &__time-section {
      width: 35%;
      height: 109px;
      border-radius: 6px;
      border: solid 1px #b4c9dd;
      overflow: hidden;
      @media screen and (max-width: 930px) {
        width: 49%;
      }
      @media screen and (max-width: 740px) {
        width: 100%;
        margin-top: 20px;
      }
      &__row-header {
        width: 100%;
        height: 40px;
        background-color: #52a0fc;
        display: inline-flex;
        justify-content: left;
        align-content: center;
        align-items: center;
        font-size: 11px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.27;
        letter-spacing: normal;
        text-align: center;
        color: #fff;
        font-family: 'Avenir-Demi';
        &__col:first-child {
          width: 27.46%;
          height: 40px;
          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
          border-right: 2px solid white;
        }
        &__col:nth-child(2) {
          border-right: 2px solid white;
        }
        &__col {
          width: 36.5%;
          height: 40px;
          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
        }
      }

      &__row {
        width: 100%;
        height: 33.5px;
        background: #f6f8fb;
        display: inline-flex;
        justify-content: left;
        align-content: center;
        align-items: center;
        font-size: 11px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.27;
        letter-spacing: normal;
        text-align: center;
        color: #132839;
        font-family: 'Avenir-Demi';
        &__col:first-child {
          width: 27.46%;
          height: 40px;
          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
          border-right: 2px solid white;
        }
        &__col:nth-child(2) {
          border-right: 2px solid white;
        }
        &__col {
          width: 36.5%;
          height: 40px;
          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
        }
      }
    }
  }
}
</style>
